
//import created component
import SectionTitle from '../../components/sectiontitle/SectionTitle.jsx'

//MUI
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

function Apropos() {



    return (

        <section className="apropos" id="apropos">
            <div className="section-container">
                <SectionTitle title={"à propos"} fontColor={"swift-lime-1"} borderColor={"swift-lime-2"} />


                <div className="apropos-top">
                    <div className="apropos-top-left">
                        <img src={require("../../images/portrait_MV_2.jpg")} title="Photo portrait de Manuel VIVION" alt="portrait de Manuel VIVION, beau gosse!" />
                    </div>
                    <div className="apropos-top-right">
                        <p>J'ai suivi et validé plusieurs formations informatiques (D.U.T. et formation diplômante en ligne). Je m'appuie sur ce socle pour poursuivre mon apprentissage autodidacte et continuer à progresser, grâce aussi à une veille technologique régulière et aux coups de pouce offerts par l'I.A.</p>
                        <div className="apropos-top-right-links">
                            <a href="https://www.manuelvivion.net/cv/CV_Manuel_VIVION_2024.pdf" target="_blank"><PictureAsPdfIcon /> <span>Mon C.V. en .pdf</span></a>
                            <a href="https://www.linkedin.com/in/manuelvivion/" target="_blank"><LinkedInIcon /> <span>Mon compte LinkedIn</span></a>
                            <a href="https://github.com/manuelvivion" target="_blank"><GitHubIcon /> <span>Mon compte Github</span></a>
                        </div>
                    </div>

                </div>
                <div className="apropos-middle">
                    <p>Je suis installé depuis plusieurs années à Lacanau. L'océan, le médoc, les fôrets.
                        <br />Avant l'océan, J'ai eu la chance de quadriller les Alpes en long et en large. Basé à Grenoble, pendant de nombreuses années j'ai  travaillé dans l'audiovisuel : prises de vues, montage, réalisation. Nombreux de mes travaux étaient en rapport direct avec les sports de glisse et de pleine nature. <br />Pour équilibrer les heures passées assis devant l'écran, c'est sur 2 roues (moto, vélo) ou sur des planches qui glissent que je vais me défouler.</p>


                </div>
                <div className="apropos-bottom">

                </div>


            </div>




            <div className="aeration-basse"></div>
        </section>


    );
}

export default Apropos;
